// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-pic-uploader.is-empty .el-upload {\n  border-style: dashed;\n}\n.d2-pic-uploader .el-upload {\n  border-color: #DCDFE6;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 4px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.d2-pic-uploader .el-upload:hover {\n  border-color: #C0C4CC;\n}\n.d2-pic-uploader .icon {\n  font-size: 28px;\n  color: #8c939d;\n  text-align: center;\n}\n.d2-pic-uploader .pic {\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
